<template>
    <div class="page container dynamicDataPage" :data-page="info.pageId">

        <!--Breadcrumbs-->
        <div class="breadcrumbs">
            <router-link to="/">Home</router-link>
            <span class="divider"><ion-icon name="chevron-forward"></ion-icon></span>
            <router-link :to="'/'+ info.pageId">{{ info.pageName }}</router-link>
        </div>
        
        <div class="pure-g">

            <!--Title-->
            <div class="pure-u-1">
                <h1 class="title">{{ info.pageName }}</h1>
                <div v-if="info.pageImage !== '' && false" class="image topImage" :style="'background-image:url('+ info.pageImage +');'"></div>
            </div>

            <!--LEFT-->
            <div class="pure-u-1 pure-u-lg-5-24 leftArea">

                <div class="actionBtns">
                    <p class="om-label">Actions</p>
                    <a href="#0" @click.prevent="toggleModal" class="btn green icon-left">
                        <ion-icon name="add-outline"></ion-icon>
                        Add New {{ info.pageNameSingular }}
                    </a>
                    <Modal
                        ref="modal"
                        :title="'Add New '+ info.pageNameSingular"
                        :type="'createNew'+ info.pageNameSingular"
                        @refresh="getAllData"
                    ></Modal>
                </div>

                <div class="filters">
                    <p class="om-label">Filters</p>
                    <nav>
                        <a href="#0" @click.prevent="filterToggle('all')" class="item" :class="{active: filterItem === 'all'}">All</a>
                        <a 
                            v-for="filter in filters"
                            :key="filter.id"
                            href="#0"
                            @click.prevent="filterToggle(filter.id)"
                            class="item"
                            :class="{active: filterItem === filter.id}"
                        >
                            {{ filter.title }}
                        </a>
                    </nav>
                </div>
                
            </div>

            <!--CENTER-->
            <div class="pure-u-1 pure-u-lg-14-24 centerArea">

                <!--Loading-->
                <div v-if="loading">
                    <div class="loading"></div>
                </div>
                <div v-else>
                    
                    <!--Empty State-->
                    <div v-if="data.length === 0" class="empty">
                        <p>No {{ info.pageName }} here yet...</p>
                    </div>

                    <!--Items list-->
                    <div v-else class="items" :data-type="info.pageId">
                        <div v-if="showData">

                            <div :id="item.id" v-for="item in data" :key="item.id" class="item" :data-type="info.pageId">
                                <div class="item_header">
                                    <div class="item_block">
                                        <div class="avatar medium" :style="{backgroundImage: 'url('+ allUsers[item.uid].photoURL +')'}">
                                            <MemberStatus :memberId="item.uid"></MemberStatus>
                                        </div>
                                    </div>
                                    <div class="item_block">
                                        <h3 class="itemTitle">{{ item.title }}</h3>
                                        <p class="itemInfo">
                                            <span class="itemAuthorName">{{ allUsers[item.uid].firstName }}</span>
                                            <span class="badge itemCategory">{{ item.category | removeSpace }}</span>
                                            <span class="itemDate">{{ item.timestamp.toDate() | moment('MMM DD, h:mm a') }}</span>
                                        </p>
                                    </div>
                                </div>
                                <div
                                    class="item_center"
                                    :class="{
                                        video: item.videoUrl
                                    }"
                                >
                                    <div class="itemContent image" :style="'background-image:url('+ item.data.thumbnail +');'">

                                        <!--Videos-->
                                        <template v-if="item.data">
                                            <div class="embedType">
                                                <!-- <iframe :src="item.data.embedUrl" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen" allowfullscreen></iframe> -->
                                                <!--
                                                    :options="{
                                                        controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'captions', 'settings', 'pip', 'airplay', 'fullscreen']
                                                    }"
                                                -->

                                                <vue-plyr>
                                                    <div :data-plyr-provider="item.data.type.toLowerCase()" :data-plyr-embed-id="item.data.id"></div>
                                                </vue-plyr>
                                            </div>
                                        </template>

                                    </div>
                                </div>
                                <div class="item_footer">

                                    <div v-if="showActionBtns(item.uid)" class="actionBtns">
                                        <a href="#0" class="delete" @click.prevent="removeData(item.id)">
                                            <ion-icon name="trash"></ion-icon>
                                        </a>
                                    </div>

                                    <Comments
                                        :isSmall="true"
                                        :type="info.pageId"
                                        :collectionId="info.pageId"
                                        :docId="item.id"
                                        :key="item.id"
                                    ></Comments>
                                </div>
                            </div>

                        </div>
                    </div><!--/Items list-->
                </div>

            </div>

            <!--RIGHT-->
            <div class="pure-u-1 pure-u-lg-5-24 rightArea">
                <Banner></Banner>
            </div>

        </div>

    </div>
</template>

<script>
    import moment from 'moment'
    const VueScrollTo = require('vue-scrollto')
    const fb = require('../firebaseConfig.js')
    import Banner from '@/components/Banner'
    import Modal from '@/components/Modal'
    import Comments from '@/components/Comments'
    import MemberStatus from '@/components/MemberStatus'

    export default {
        data(){
            return{
                allUsers: null,
                info: {
                    pageName: 'Videos',
                    pageId: 'videos',
                    pageNameSingular: 'Video',
                    pageImage: 'https://images.prismic.io/vanmglcom/d33c22f2-50f2-4b37-a059-111e14ef4f67_0d1fda96630667.5eb2bfd321000.jpg?auto=compress,format'
                },
                dataRef: fb.videosCollection,
                data: [],
                loading: true,
                filters: [
                    {
                        title: 'Stories',
                        id: 'stories',
                        count: 0
                    },
                    {
                        title: 'Other',
                        id: 'other',
                        count: 0
                    }
                ],
                filterItem: 'all',
                showData: false,
                comments: {
                    init: null,
                    textArea: '',
                    error: null
                }
            }
        },
        
        components: {
            Banner,
            Modal,
            Comments,
            MemberStatus
        },
        
        mounted(){
            this.allUsers = this.$store.state.allUsers
            this.getAllData()

            if(this.$route.query.action === 'create'){
                this.toggleModal()
                window.history.pushState('videos', 'Videos', '/videos')
            }
        },

        methods: {
            // CRUD Functions
            getAllData(){

                let ref = this.dataRef.orderBy('timestamp', 'desc')

                ref.get().then(snap => {
                    if(snap){

                        let allData = []

                        snap.forEach(doc => {
                            let data = {}
                            
                            data = doc.data()
                            data.id = doc.id

                            if(this.filterItem !== 'all'){
                                if(this.filterItem === data.category){
                                    allData.push(data)
                                }
                            }else{
                                allData.push(data)
                            }
                        })

                        this.data = allData
                        allData = []

                        this.loading = false
                        this.showData = true

                        this.scrollToCheck()
                    
                    }else{
                        console.log('No data found!')

                        this.loading = false
                        this.showData = false
                    }
                }).catch(err => {
                    console.log('Error getting all data: ', err)

                    this.loading = false
                    this.showData = false
                })
            },
            removeData(id){
                if(confirm('Are you sure you want to remove this '+ this.info.pageNameSingular + '?')){

                    let ref = this.dataRef.doc(id)

                    this.loading = true
                    this.showData = false

                    ref.delete().then(() => {
                        
                        this.$notify({
                            group: 'globalNotifications',
                            title: 'Successfully removed video.'
                        })

                        this.getAllData()
                    })
                    .catch(err => {
                        console.log('Error removing '+ this.info.pageNameSingular +': ', err)
                        this.loading = false
                    })
                }
            },

            // Helper functions
            scrollToCheck(){
                if(this.$route.query.item){
                    setTimeout(() => {
                        let elItem = document.getElementById(this.$route.query.item)
                        if(elItem !== null){
                            this.$scrollTo(elItem, 700, {
                                offset: -60
                            })
                        }
                    }, 1500)
                }
            },
            toggleModal(){
                if(this.$store.state.currentUser === null){
                    alert('You need to login first!')
                    this.$router.push('/login')
                }else{
                    this.$refs.modal.toggleModal()
                }
            },
            filterToggle(item){
                this.filterItem = item
                this.loading = true
                this.showData = false

                this.getAllData()
            },
            showActionBtns(id){

                let show = false

                if(this.$store.state.currentUser !== null){
                    if(this.$store.state.currentUser.uid === id){
                        show = true
                    }
                    if(this.$store.state.currentUser.uid === 'MxARUElzBNhyyJbdwYkOL55vxxJ2'){
                        show = true
                    }
                }

                return show
            },
            checkLastOnlineTime(user, offline){
                if(user.status === 'online') return null

                let today = moment()
                let lastOnline = moment(user.timestamp)
                let min = today.diff(lastOnline, 'minutes')

                if(offline === 'offline'){
                    return lastOnline.format('MMM D, YYYY - h:mm a')
                }

                if(min < 60){
                    return min + 'm'
                }

                return null
            }
        },
        filters: {
            removeSpace(value){
                if(!value) return
                return value.replace('_',' ') 
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/Videos.vue